/*
** OBLeben2040 Export
*/

function loadScript(url) {
	return new Promise(function(resolve, reject) {
		let script = document.createElement('script');
        script.type = "text/javascript";
		script.src = url;
		script.async = false;

		script.onload = function() {
			resolve(url);
		};
		script.onerror = function() {
			reject(url);
		};

		document.getElementsByTagName("head")[0].appendChild(script);
	});
}

function loadStylesheet(url) {
	return new Promise(function(resolve, reject) {
		let stylesheet = document.createElement('link');
        stylesheet.rel = "stylesheet";
		stylesheet.href = url;
        stylesheet.type = "text/css";
		stylesheet.async = false;

		stylesheet.onload = function() {
			resolve(url);
		};
		stylesheet.onerror = function() {
			reject(url);
		};

		document.getElementsByTagName("head")[0].appendChild(stylesheet);
	});
}

function calcVoteLabel(value) {
	if(value > 1) {
		return String(value + ' Stimmen');
	} else {
		return String(value + ' Stimme');
	}
}

// Poll Graphic

function createPollGraph(container, data, name, question, image) {
	let dataArray = Object.entries(data)[0][1];
	let pollArray = [];
	let pollGraph = document.createElement('div');
		pollGraph.className = 'poll--container';

	let PollGraphHeader = document.createElement('header');
		PollGraphHeader.className = 'artikel-nav poll--header clearfix';

	let pollGraphHeaderBtnBack = document.createElement('a');
		pollGraphHeaderBtnBack.className = 'btn btn_back';
		pollGraphHeaderBtnBack.setAttribute('title', 'Zurück zur Themenübersicht');
		pollGraphHeaderBtnBack.appendChild(document.createTextNode(''));

		pollGraphHeaderBtnBack.addEventListener('click', function(e) {
			e.preventDefault();
			fetchObLebenPollData();
		});

		PollGraphHeader.appendChild(pollGraphHeaderBtnBack);
		container.appendChild(PollGraphHeader);

	let pollGraphContent = document.createElement('div');
		pollGraphContent.className = 'poll--content';

	let pollGraphList = document.createElement('ul');
		pollGraphList.className = 'poll--summary';

	let pollHeader = document.createElement('header');
		pollHeader.className = 'poll--header';
		pollHeader.style.backgroundImage = 'url(/dgimages/obleben2040/header-' + image + ')';
	let pollHeaderContent = document.createElement('div');
		pollHeaderContent.className = 'poll--header__content';

	let pollTitle = document.createElement('h2');
		pollTitle.appendChild(document.createTextNode(name));
		pollTitle.className = 'poll--title';
	let pollQuestion = document.createElement('h3');
		pollQuestion.className = 'poll--question';
		pollQuestion.appendChild(document.createTextNode(question));

		pollHeaderContent.appendChild(pollTitle);
		pollHeaderContent.appendChild(pollQuestion);

		pollHeader.appendChild(pollHeaderContent);
		pollGraphContent.appendChild(pollHeader);
		
	if(dataArray.length > 0) {
		for(let i = 0; i < dataArray.length; i++) {
			if(pollArray.some(row => row.includes(dataArray[i].value))) {
				for(let e = 0; e < pollArray.length; e++) {
					if(pollArray[e][0] === String(dataArray[i].value)) {
						pollArray[e][1]++;
					}
				}
			} else {
				pollArray.push([dataArray[i].value, 1])
			}
		}
	}

	for(let p = 0; p < pollArray.length; p++) {
		let pollLabel = pollArray[p][0];
		let pollValue = pollArray[p][1];
		let pollTotalValue = Math.round((pollValue / dataArray.length) * 100);
		let pollVoteValue = calcVoteLabel(pollValue);

		let pollGraphEntry = document.createElement('li');
			pollGraphEntry.className = 'poll--summary__entry';
		let pollGraphEntryName = document.createElement('label');
			pollGraphEntryName.className='poll--entry__name';
			pollGraphEntryName.innerText = pollLabel;
		let pollGraphBGBar = document.createElement('div');
			pollGraphBGBar.className = 'poll--entry__bar';
		let pollGraphValueBar = document.createElement('div');
			pollGraphValueBar.className = 'poll--entry__currbar';
			pollGraphValueBar.setAttribute('data-value', pollTotalValue);
			pollGraphValueBar.style.width = String(pollTotalValue) + '%';
			pollGraphBGBar.appendChild(pollGraphValueBar);

		let polLGraphTooltipValue = document.createElement('span');
			polLGraphTooltipValue.className = 'poll--entry__tooltip';
			polLGraphTooltipValue.innerText = String(pollTotalValue) + '%';
			polLGraphTooltipValue.style.visibility = 'hidden';
			polLGraphTooltipValue.style.left = String(pollTotalValue) + '%';
			pollGraphBGBar.appendChild(polLGraphTooltipValue);

		let pollGraphEntryValue = document.createElement('span');
			pollGraphEntryValue.className = 'poll--entry__value';
			pollGraphEntryValue.innerText = pollVoteValue;

			pollGraphEntry.appendChild(pollGraphEntryName);
			pollGraphEntry.appendChild(pollGraphBGBar);
			pollGraphEntry.appendChild(pollGraphEntryValue);
			pollGraphList.appendChild(pollGraphEntry);
	}

	pollGraphContent.appendChild(pollGraphList);
	pollGraph.appendChild(pollGraphContent);

	return pollGraph;
}

// Poll Entry Modal

function openPollModal(date, author, description, state, weight) {
    let title = document.querySelector('.poll--question').innerText;
	let pollModalBox = document.createElement('div');
        pollModalBox.className = '';
        pollModalBox.setAttribute('id', 'pollModalBox');

        let pollModalHeader = document.createElement('header');
            pollModalHeader.className = 'poll--modal__header';
        let pollModalTitle = document.createElement('h2');
            pollModalTitle.className = 'poll--modal__title';
            pollModalTitle.innerText = title;
        let pollModalAuthor = document.createElement('span');
            pollModalAuthor.className = 'poll--modal__author';
            pollModalAuthor.innerText = 'Geschrieben von ' + author + ' am ' + date;
        let pollModalState = document.createElement('span');
            pollModalState.className = 'poll--modal__weight entry--' + weight;
            pollModalState.innerText = state;

            pollModalHeader.appendChild(pollModalTitle);
            pollModalHeader.appendChild(pollModalState);
            pollModalHeader.appendChild(pollModalAuthor);

        let pollModalContent = document.createElement('div');
            pollModalContent.className = 'poll--modal__content';
        let pollModalDescription = document.createElement('p');
            pollModalDescription.className = 'poll--modal__description';
            pollModalDescription.innerText = description;

            pollModalContent.appendChild(pollModalDescription);

        let pollModalFooter = document.createElement('footer');
            pollModalFooter.className = 'poll--modal__footer';
        let pollModalBtn = document.createElement('button');
            pollModalBtn.className = 'btn poll--modal__btn';
            pollModalBtn.innerText = 'Schließen';

            pollModalBtn.addEventListener('click', function(e) {
                e.preventDefault();
                toggleOverlay(false);
            });

            pollModalFooter.appendChild(pollModalBtn);

            pollModalBox.appendChild(pollModalHeader);
            pollModalBox.appendChild(pollModalContent);
            pollModalBox.appendChild(pollModalFooter);

		toggleOverlay(true, pollModalBox, {
            fullwidth: true
        });
}

// Poll Entries

function fetchPollValueWeight(state) {
    switch(state) {
        case 'Eher wichtig':
            return 'important';
        case 'Sehr wichtig':
            return 'very-important';
        case 'Eher nicht wichtig':
            return 'regular';
        case 'Gar nicht wichtig':
            return 'not-very-important';
        default:
            return 'no-value';
    }
}

function createPollEntry(container, data) {
	let dataArray = Object.entries(data)[0][1];
	let pollWrapper = 0;
	let pollTotalVisibleCount = 0;
	let pollDetailWrapper = document.createElement('div');
		pollDetailWrapper.className = '';

	let pollDetailList = document.createElement('ul');
	
	for(let i = 0; i < dataArray.length; i++) {
		let entryStatus = false;
		let pollValueDate = String(dataArray[i].createdDate);
		let pollValueState = String(dataArray[i].value);
        let pollValueWeight = fetchPollValueWeight(pollValueState);
		let pollValueDescription = String(dataArray[i].Beitragstext);
		let pollValuePreview = pollValueDescription.substring(0, 200) + '...'

		if(pollValueDescription !== 'null') {
			entryStatus = true;
			pollTotalVisibleCount = pollTotalVisibleCount + 1;
		}
	
		let pollEntry = document.createElement('li');
			pollEntry.className = 'poll--entry';
			pollEntry.setAttribute('data-id', dataArray[i].id);
			pollEntry.setAttribute('tabindex', '0');
			pollEntry.style.display = entryStatus ? 'flex' : 'none';
		let pollAvatar = document.createElement('div');
			pollAvatar.className = 'poll--entry__avatar';
		let pollContent = document.createElement('div');
			pollContent.className = 'poll--entry__content';

		let pollEntryValue = document.createElement('span');
			pollEntryValue.className = 'poll--entry__value entry--' + pollValueWeight;
			pollEntryValue.innerText = pollValueState;
			pollContent.appendChild(pollEntryValue);
		let pollEntryDate = document.createElement('time');
			pollEntryDate.className = 'poll--entry__time';
			pollEntryDate.innerText = pollValueDate;
			pollContent.appendChild(pollEntryDate);
		let pollEntryDescription = document.createElement('p');
			pollEntryDescription.innerText = pollValuePreview;
			pollEntryDescription.className = 'poll--entry__description';
			pollContent.appendChild(pollEntryDescription);

		pollEntry.appendChild(pollAvatar);
		pollEntry.appendChild(pollContent);

		pollEntry.addEventListener('click', function(e) {
			e.preventDefault();
			openPollModal(pollValueDate, 'Gast', pollValueDescription, pollValueState, pollValueWeight);
		});

		pollDetailList.appendChild(pollEntry)
	}

	pollDetailWrapper.appendChild(pollDetailList);

	if(dataArray.length >= 10) {
		pollDetailList.className = 'poll--list';
		let pollFooter = document.createElement('footer');
			pollFooter.className = 'poll--list__footer';
		let pollDetailMoreBtn = document.createElement('button');
            pollDetailMoreBtn.innerText = 'Alle Kommentare anzeigen (' + String(pollTotalVisibleCount) + ')';
            pollDetailMoreBtn.className = 'btn bigbtn poll--show__more';
		pollDetailList.classList.add('is--restricted');
		pollFooter.appendChild(pollDetailMoreBtn);

        if(document.body.clientWidth >= 1024) {
            pollFooter.style.maxWidth = String(document.querySelector('.content').offsetWidth) + 'px';
        }

		pollDetailMoreBtn.addEventListener('click', function(e) {
			e.preventDefault();
	
			if(pollDetailList.classList.contains('is--restricted')) {
				pollDetailList.classList.remove('is--restricted');
				pollFooter.classList.add('is--moving');
				pollDetailMoreBtn.innerText = 'Kommentare ausblenden';
			} else {
				pollDetailList.classList.add('is--restricted');
				pollFooter.classList.remove('is--moving');
				pollDetailMoreBtn.innerText = 'Alle Kommentare anzeigen (' + String(pollTotalVisibleCount) + ')';
			}
		})

		pollDetailWrapper.appendChild(pollFooter);

        window.addEventListener('resize', function() {
            let isSidebarThere = document.querySelectorAll('.sidebar');
            // Resize
    
            // Going to Desktop from Mobile
            if(document.body.clientWidth >= 1024) {
                //Desktop
                if(pollFooter.classList.contains('is--moving')) {
                    // when moving
                    pollFooter.style.maxWidth = String(document.querySelector('.content').offsetWidth) + 'px'; // footer width to content width
    
                    // if is bottom
                    //// adjust bottom value
                    if (window.innerHeight + window.pageYOffset >= (document.body.scrollHeight - Number(document.querySelector('.page--footer').offsetHeight) - 75)) {
                        pollFooter.classList.remove('is--moving');
                        pollFooter.style.bottom = '0px'; // Desktop bottom reached
                    } else {
                        pollFooter.classList.add('is--moving');
                        pollFooter.style.bottom = '0px';  // Mobile bottom not reached
                    }
                } else {
                    pollFooter.style.bottom = '';
                    pollFooter.style.maxWidth = '';
                }
            } else {
                // Going to Mobile
                if(pollFooter.classList.contains('is--moving')) {
                    // when moving
                    pollFooter.style.bottom = '0px';
                    pollFooter.style.maxWidth = 'calc(100% - 62px)';
    
                    // if is bottom
                    //// adjust bottom value
                    if (window.innerHeight + window.pageYOffset >= (document.body.scrollHeight - (Number(isSidebarThere.length) > 0 ? Number(document.querySelector('.sidebar').scrollHeight) : 0) - Number(document.querySelector('.page--footer').scrollHeight) - 75)) {
                        pollFooter.classList.remove('is--moving'); // while moving
                        pollFooter.style.bottom = '0px';  // Mobile bottom not reached
                    } else {
                        pollFooter.classList.add('is--moving'); // at the bottom
                        pollFooter.style.bottom = '0px';  // Mobile bottom not reached
                    }
    
                } else {
                    pollFooter.style.bottom = '0px';
                    pollFooter.style.maxWidth = 'calc(100% - 62px)';
                }
            }
        });
    
        window.addEventListener('scroll', function() {
            // Scroll
            // Desktop is-moving - what happens when bottom is reached
            // Mobile is-moving - what happens when bottom is reached
            let isSidebarThere = document.querySelectorAll('.sidebar');
    
            if(document.body.clientWidth >= 1024) {
                if(pollFooter.classList.contains('is--moving')) {
                    if (window.innerHeight + window.pageYOffset >= (document.body.scrollHeight - Number(document.querySelector('.page--footer').offsetHeight) - 50)) {
                        pollFooter.style.bottom = '235px'; // Desktop bottom reached
                    } else {
                        pollFooter.style.bottom = '0px'; // Desktop bottom not reached
                    }
                }
            } else {
                if(pollFooter.classList.contains('is--moving')) {
                    if (window.innerHeight + window.pageYOffset < (document.body.scrollHeight - (Number(isSidebarThere.length) > 0 ? Number(document.querySelector('.sidebar').scrollHeight) : 0) - Number(document.querySelector('.page--footer').scrollHeight) - 75)) {
                        pollFooter.style.bottom = '0px';  // Mobile bottom not reached
                    } else {
                        pollFooter.style.bottom = '375px'; // Mobile bottom reached
                    }
                }
            }
        });
	}

	return pollDetailWrapper;
}

function loadContentPlaceholder() {
    let loadingContainer = document.createElement('div');
        loadingContainer.className = 'loading--container';
    let loading = document.createElement('div');
        loading.className = 'loading';
        loadingContainer.appendChild(loading);
    let loadingContent = document.createElement('span');
        loadingContent.className = 'loading--content';
        loadingContent.innerText = 'Inhalte werden geladen...';
        loadingContainer.appendChild(loading);
        loadingContainer.appendChild(loadingContent);

    return loadingContainer;
}

// Fetch Poll Data

async function fetchPollDataList(container, name, question, image, data={}) {
    container.appendChild(loadContentPlaceholder());

	const response = await fetch('https://dls.dg.be/services/obleben2040/umfrage?categoryname=' + encodeURIComponent(name), {
		method: 'GET',
		mode: 'cors'
	})
	.then(response => response.json())
	.then(data => {
        container.innerHTML = '';
		container.appendChild(createPollGraph(container, data, name, question, image));
		container.appendChild(createPollEntry(container, data));
	})
	.catch(function(error) {
        console.error(error);
    });
}

// Poll Detail Page

function createPollDetail(id, name, question, image) {
	let container = fetchObLebenContainer();
	// Resett container
	container.innerHTML = '';

	// Create new container
	let pollDetail = document.createElement('article');
		pollDetail.className = 'artikel-detail poll--category__detail';
		pollDetail.setAttribute('data-id', id);
		pollDetail.setAttribute('data-name', name);

	fetchPollDataList(pollDetail, name, question, image);

	container.appendChild(pollDetail);
}

// Create Poll Topics

function createPollTopics(data, list) {
	let topicData = Object.entries(data)[0][1];

	for(let i = 0; i < topicData.length; i++) {
		let pollCategory = document.createElement('li');
			pollCategory.className = 'poll--category';
			pollCategory.setAttribute('data-id', topicData[i].id);
			pollCategory.setAttribute('data-category', topicData[i].name);
		let pollCategoryLink = document.createElement('a');
			pollCategoryLink.className = 'poll--category__anchor';
		let pollCategoryHeader = document.createElement('header');
			pollCategoryHeader.className = 'poll--category__header';
		let pollCategoryName = document.createElement('h3');
			pollCategoryName.className = 'poll--category__title';
			pollCategoryName.appendChild(document.createTextNode(topicData[i].name));
		let pollCategoryImage = document.createElement('img');
			pollCategoryImage.className = 'poll--category__image';
			pollCategoryImage.setAttribute('src', '/dgimages/obleben2040/image-' + topicData[i].image);
		let polLCategoryButton = document.createElement('button');
			polLCategoryButton.appendChild(document.createTextNode('Beiträge anzeigen'));
			polLCategoryButton.className = 'btn bigbtn';

		pollCategoryHeader.appendChild(pollCategoryImage);
		pollCategoryHeader.appendChild(pollCategoryName);
		pollCategoryLink.appendChild(pollCategoryHeader);
		// pollCategoryLink.appendChild(polLCategoryButton);
		pollCategory.appendChild(pollCategoryLink);

		pollCategory.addEventListener('click', function(e) {
			e.preventDefault();
			createPollDetail(topicData[i].id, topicData[i].name, topicData[i].question, topicData[i].image);
		});

		list.appendChild(pollCategory);
	}

	return list;
}

// Poll Category - Entries

async function createPollCategory(container, list) {
	const response = await fetch('/dgdata/ostbelgienleben2040/data_topics.json', {
		method: 'GET',
		mode: 'cors'
	})
	.then(response => response.json())
	.then(data => {
		container.appendChild(createPollTopics(data, list));
	})
	.catch(function(error) {
        console.error(error);
    });
}

// Poll-Category List

function listPollTopicsSelection(container) {
	let pollList = document.createElement('ul');
		pollList.className = 'poll--category__list';

	// createBreadcrumbEntry('Themenauswahl');
	createPollCategory(container, pollList);

	return pollList;
}

function fetchObLebenPollData(container) {
	let pollContainer;

	if(container  !== 'underfined') {
		pollContainer = document.querySelector('#ObLebenExport');
	} else {
		pollContainer = container;
	}

	pollContainer.innerHTML = '';
	pollContainer.appendChild(listPollTopicsSelection(pollContainer));
}

/////////////////////////////

// Map entries

function convertCoordsStringtoFloat(input) {
	if(typeof input === 'string') {
		return parseFloat(input.replace(',', '.').replaceAll(',', ''));
	} else {
		console.error('Cannot convert Coordinates: no string input!');
	}
}

function convertMarkerState(input) {
	switch(input) {
		case 'Lieblingsort':
			return 'orange';
			break;
		case 'Schützenswerter Ort':
			return 'pink';
			break;
		case 'Veränderungswürdiger Ort':
			return 'blue';
			break;
		case 'Touristischer Ort':
			return 'sky';
			break;
		case 'Familien-Ort':
			return 'green';
			break;
		default:
			return 'no__state';
	}
}

function createFilterArray(data, filterEntries = []) {
	for(let i = 0; i < data.length; i++) {
		if(!filterEntries.includes(convertMarkerState(data[i].state))) {
			filterEntries.push(convertMarkerState(data[i].state));
		}
	}

	return filterEntries;
}

function toggleMapMarkers(state, marker) {
	let markerList = document.querySelectorAll('.map--marker');

	for(let i = 0; i < markerList.length; i++) {
		if(markerList[i].classList.contains('marker--' + marker)) {
			if(state === true) {
				markerList[i].classList.add('is--active');
			} else {
				markerList[i].classList.remove('is--active');
			}
		}
	}
}

function fetchMarkerCount(state) {
	return String(document.querySelectorAll('.marker--' + state).length);
}

function createMapFilterList(data) {
	let dataArray = Object.entries(data)[0][1];
	let dataCount = [];
	let container = document.createElement('div');
		container.className = 'map--filters';

	let filterList = document.createElement('ul');
		filterList.className = 'map--filters__list';

	let filterEntries = createFilterArray(dataArray);

    console.log(filterEntries);

	for(let i = 0; i < filterEntries.length; i++) {
		let filterElement = document.createElement('li');
			filterElement.className = 'filter filter--marker__' + filterEntries[i] + ' is--active';

		let filterElementBtn = document.createElement('button');
			filterElementBtn.className = 'btn';
		
		let filterElementLabel = document.createElement('span');
			filterElementLabel.appendChild(document.createTextNode(filterEntries[i]));
			filterElementBtn.appendChild(filterElementLabel);

			filterElement.appendChild(filterElementBtn);
			filterList.appendChild(filterElement);

			filterElementBtn.addEventListener('click', function(e) {
				e.preventDefault();

				if(filterElement.classList.contains('is--active')) {
					filterElement.classList.remove('is--active');
					toggleMapMarkers(false, filterEntries[i]);
				} else {
					filterElement.classList.add('is--active');
					toggleMapMarkers(true, filterEntries[i]);
				}
			});
	}

	container.appendChild(filterList);
	document.querySelector('#ObLebenExport').appendChild(container);
}

/*
** Map
*/

function toggleGroup(id, state, mcgLayerSupportGroup, orange, pink, blue, sky, green) {
    let group = id == 1 ? orange : id == 2 ? pink : id == 3 ? blue : id == 4 ? sky : green;
    let selector = id == 1 ? 'orange' : id == 2 ? 'pink' : id == 3 ? 'blue' : id == 4 ? 'sky' : 'green';

    if(state === true) {
        mcgLayerSupportGroup['addLayer'](group);
    } else {
        mcgLayerSupportGroup['removeLayer'](group);
    }

    document.querySelectorAll('.entry--' + selector).forEach(entry => {
        if(entry.classList.contains('is--active')) {
            entry.classList.remove('is--active');
        } else {
            entry.classList.add('is--active');
        }
    });

    let activeAmount = document.querySelectorAll('.map--post__entry.is--active').length;
    document.querySelector('.map--post__list').setAttribute('data-active', activeAmount);
}

function createMapFilters(container, mcgLayerSupportGroup, orange, pink, blue, sky, green) {
    let filterEntryList = {
        'Lieblingsort': orange,
        'Schützenswerter Ort': pink,
        'Veränderungswürdiger Ort': blue,
        'Touristischer Ort': sky,
        'Familien-Ort': green
    };

    let arrayEntryList = Object.entries(filterEntryList);

    // Container
    let mapFilters = document.createElement('section');
        mapFilters.className = 'map--filter__container';
        mapFilters.setAttribute('id', 'mapFilters');

    // Dropdown
    let mapFiltersDropdown = document.createElement('div');
        mapFiltersDropdown.className = 'dropdown';
        mapFiltersDropdown.setAttribute('id', 'mapFiltersDropdown');

    // Dropdown Button
    let mapFiltersBtn = document.createElement('button');
        mapFiltersBtn.className = 'btn';
        mapFiltersBtn.setAttribute('type', 'button');
        mapFiltersBtn.setAttribute('data-toggle', 'dropdown');
        mapFiltersBtn.setAttribute('aria-expanded', 'false');
        mapFiltersBtn.setAttribute('id', 'mapFiltersBtn');
        mapFiltersBtn.appendChild(document.createTextNode('Kategorien auswählen'));

    // Dropdown List
    let mapFiltersList = document.createElement('ul');
        mapFiltersList.className = 'map--filter__list';
        mapFiltersList.setAttribute('id', 'mapFiltersList');
        mapFiltersList.setAttribute('aria-labelledby', 'mapFiltersBtn');

    // Event Listener
    mapFiltersBtn.addEventListener('click', function(e) {
        e.preventDefault();

        if(mapFiltersBtn.getAttribute('aria-expanded') === 'false') {
            mapFiltersBtn.setAttribute('aria-expanded', 'true');
            mapFiltersList.classList.add('is--visible');
        } else {
            mapFiltersBtn.setAttribute('aria-expanded', 'false');
            mapFiltersList.classList.remove('is--visible');
        }
    });
    document.addEventListener('mouseup', function(e) {
		if(String(e.target.id) !== 'mapFiltersList') {
			mapFiltersBtn.setAttribute('aria-expanded', 'false');
			mapFiltersList.classList.remove('is--visible');
		}
        if(String(e.target.id) === 'mapFiltersBtn') {
            mapFiltersBtn.setAttribute('aria-expanded', 'false');
			mapFiltersList.classList.remove('is--visible');
        }
	});

    // Filter entries
    for(let i = 0; i < arrayEntryList.length; i++) {
        let mapFilterEntry = document.createElement('li');
            mapFilterEntry.className = 'map--filter__entry';
            // mapFilterEntry.setAttribute('id', 'mapFilterEntry');

        let mapFilterEntryBtn = document.createElement('button');
            mapFilterEntryBtn.className = 'map--filter is--active';
            mapFilterEntryBtn.setAttribute('type', 'button');
            mapFilterEntryBtn.setAttribute('data-toggle', 'dropdown');
            mapFilterEntryBtn.setAttribute('aria-expanded', 'true');
            mapFilterEntryBtn.setAttribute('data-group', i + 1);
            mapFilterEntryBtn.appendChild(document.createTextNode(arrayEntryList[i][0]));
        let mapFilterEntryCount = document.createElement('span');
            mapFilterEntryCount.className = 'map--filter__count';
            mapFilterEntryCount.appendChild(document.createTextNode(Object.entries(filterEntryList)[i][1].getLayers().length));

            mapFilterEntryBtn.appendChild(mapFilterEntryCount);
            
            mapFilterEntryBtn.addEventListener('click', function(e) {
                e.preventDefault();
                
                if(mapFilterEntryBtn.getAttribute('aria-expanded') === 'true') {
                    // remove
                    mapFilterEntryBtn.setAttribute('aria-expanded', 'false');
                    mapFilterEntryBtn.classList.remove('is--active');
                    toggleGroup(String(i + 1), false, mcgLayerSupportGroup, orange, pink, blue, sky, green);
                } else {
                    // add
                    mapFilterEntryBtn.setAttribute('aria-expanded', 'true');
                    mapFilterEntryBtn.classList.add('is--active');
                    toggleGroup(String(i + 1), true, mcgLayerSupportGroup, orange, pink, blue, sky, green);
                }
            });

            mapFilterEntry.appendChild(mapFilterEntryBtn);
            mapFiltersList.appendChild(mapFilterEntry);
    }

    mapFiltersDropdown.appendChild(mapFiltersBtn);
    mapFiltersDropdown.appendChild(mapFiltersList);

    mapFilters.appendChild(mapFiltersDropdown);
    container.appendChild(mapFilters);
}

async function fetchOstbelgienGeoJSON(map) {
	const response = await fetch('/dgdata/ostbelgienleben2040/data_dg-boundaries.json', {
		method: 'GET',
		mode: 'cors'
	})
	.then(response => response.json())
	.then(data => {
		L.geoJSON(data.poly_bounds, {
			color: "#333333",
			weight: 3,
			opacity: 0.75,
			fillOpacity: 0.5
		}).addTo(map);
	})
	.catch(function(error) {
        console.error(error);
    });
}

function initLeaflet(container, mapcontainer, data) {
    let tiles = new L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
    });

    let map = new L.map('map', {
        center: L.latLng(50.429899496628295, 6.116357000000021),
        zoom: 9,
        tileSize: 512,
        zoomOffset: -1,
        attributionControl: true,
        closePopupOnClick: true,
        doubleClickZoom: true,
        dragging: true,
        fadeAnimation: true,
        layerControl: true,
        minZoom: 0,
        scrollWheelZoom: 1,
        touchZoom: true,
        trackResize: true,
        zoomAnimation: true,
        zoomControl: true,
        layers: [tiles]
    });

    const resizeObserver = new ResizeObserver(() => {
        map.invalidateSize();
    });
    resizeObserver.observe(mapcontainer);

    let stateFullscreenBtn = L.easyButton({
        states: [{
            stateName: 'fullscreen-on',
            icon: '<i class="icon icon--expand"></i>',
            title: 'Karte erweitern',
            onClick: function(btn, map) {
                map.setView([50.429899496628295, 6.116357000000021],9)
                document.querySelector('.sidebar').style.display = 'none';
                subnavContainer.style.display = 'none';
                document.querySelector('.content').classList.add('is--expanded');
                document.querySelector('#mapEntries').classList.add('is--fullwidth');

                if(document.body.clientWidth >= 1024) {
                    document.querySelector('.map--list__footer').style.maxWidth = '780px';
                } else {
                    document.querySelector('.map--list__footer').style.maxWidth = '100%';
                }

                btn.state('fullscreen-off')
            }
        },
        {
            stateName: 'fullscreen-off',
            icon: '<i class="icon icon--compress"></i>',
            title: 'Karte einschraenken',
            onClick: function(btn, map) {
                map.setView([50.429899496628295, 6.116357000000021],8)
                document.querySelector('#mapEntries').classList.remove('is--fullwidth');
                document.querySelector('.content').classList.remove('is--expanded');
                document.querySelector('.sidebar').style.display = 'block';

                subnavContainer.style.display = 'block';
                btn.state('fullscreen-on')
            }
        }]
    });

    stateFullscreenBtn.addTo(map);

    let mcgLayerSupportGroup = L.markerClusterGroup.layerSupport(),
        orange = L.layerGroup(),
        pink = L.layerGroup(),
        blue = L.layerGroup(),
        sky = L.layerGroup(),
        green = L.layerGroup(),
        control = L.control.layers(null, null, { collapsed: false }),
        i, a, title, marker;

        mcgLayerSupportGroup.addTo(map);

    fetchOstbelgienGeoJSON(map);

	for(let i = 0; i < data.length; i++) {
		let id = data[i].id,
            title = String(data[i].title),
            date = String(timeConverter(Date.parse(data[i].createdDate))),
            resumee = String(data[i].description).substring(0, 100) + '...',
            description = String(data[i].description),
            lat = convertCoordsStringtoFloat(data[i].lat),
            lon = convertCoordsStringtoFloat(data[i].lon),
            category = convertMarkerState(data[i].state),
            catfull = String(data[i].state),
            coords = [lat, lon],
            address = String(data[i].address);

        let popupContainer = document.createElement('div');
            popupContainer.className = 'marker--popup';
            popupContainer.setAttribute('data-id', id);
        let popupMarkupContainer = document.createElement('div');
            popupMarkupContainer.className = 'marker--popup__markup';
        let popupMarker = document.createElement('div');
            popupMarker.className = 'marker marker--' + category;

            popupMarkupContainer.appendChild(popupMarker);
            popupContainer.appendChild(popupMarkupContainer);

        let popupContent = document.createElement('div');
            popupContent.className = 'marker--popup__content';
        let popupTitle = document.createElement('h3');
            popupTitle.className = 'marker--title';
            popupTitle.innerText = title;
        let popupDescription = document.createElement('p');
            popupDescription.className = 'marker--description';
            popupDescription.innerText = resumee;
        let popupReadmore = document.createElement('button');
            popupReadmore.className = 'btn bigbtn';
            popupReadmore.innerText = 'Beitrag lesen';
            
            popupReadmore.addEventListener('click', function(e) {
                e.preventDefault();
                openMapEntryModal(data, catfull, title, date, description, lat, lon, category, address);
            });

            popupContent.appendChild(popupTitle);
            popupContent.appendChild(popupDescription);
            popupContent.appendChild(popupReadmore);

            popupContainer.appendChild(popupContent);
        
        marker = new L.marker(coords, {
            icon: L.divIcon({
                className: 'marker--icon',
                html: '<div class="marker map--marker marker--' + category + ' is--active" data-name="' + title + '" data-lat="' + String(lat) + '" data-lon="' + String(lon) + '">' + title + '</div>'
            })
        });
        marker.bindPopup(popupContainer);
        marker.addTo(category === 'orange' ? orange : category === 'pink' ? pink : category === 'blue' ? blue : category === 'sky' ? sky : green);
	}

    mcgLayerSupportGroup.checkIn([orange, pink, blue, sky, green]);

    orange.addTo(map);
    pink.addTo(map);
    blue.addTo(map);
    sky.addTo(map);
    green.addTo(map);

    createMapFilters(container, mcgLayerSupportGroup, orange, pink, blue, sky, green);
}

// Load Leaflet Assets

function loadLeaflet(container, mapcontainer, data) {
    let scripts = [
        '/dgscripts/vendors/leaflet/leaflet.js',
        '/dgscripts/vendors/leaflet/leaflet.markercluster.js',
        '/dgscripts/vendors/leaflet/leaflet.markercluster.layersupport.js',
        '/dgscripts/vendors/leaflet/easy-button.js'
    ];
    let styles = [
        '/dgcss/vendors/leaflet/leaflet.css',
        '/dgcss/vendors/leaflet/MarkerCluster.css',
        '/dgcss/vendors/leaflet/MarkerCluster.Default.css',
        '/dgcss/vendors/leaflet/easy-button.css'
    ];

    let promises = [];

    scripts.forEach(function(url) {
        promises.push(loadScript(url));
    });

    styles.forEach(function(url) {
        promises.push(loadStylesheet(url));
    });

    Promise.all(promises)
    .then(function() {
        initLeaflet(container, mapcontainer, data);
    }).catch(function(asset) {
        console.log(asset + ' failed to load');
    });
}

function createLeafletMap(container, data) {
    let mapEntries = data[1];

    // MapContainer
	let mapContainer = document.createElement('div');
    mapContainer.setAttribute('id', 'map');
    mapContainer.style.height = '420px';

    container.appendChild(mapContainer);

    loadLeaflet(container, mapContainer, mapEntries);
}

// Entry Overlay

function openMapEntryModal(data, category, title, date, description, lat, lon, state, address) {
    let mapEntryBox = document.createElement('div');
        mapEntryBox.className = '';
        mapEntryBox.setAttribute('id', 'mapEntryBox');

    let mapEntryHeader = document.createElement('header');
        mapEntryHeader.className = 'modal--entry__header is--restricted';

    let mapEntrySummary = document.createElement('div');
        mapEntrySummary.className = 'modal--content';
        mapEntrySummary.setAttribute('id', 'mapEntrySummary');

        let mapEntryCategory = document.createElement('span');
            mapEntryCategory.appendChild(document.createTextNode(category));
            mapEntryCategory.className = 'modal--entry__category category--' + String(state);
        let mapEntryAddress = document.createElement('address');
            mapEntryAddress.appendChild(document.createTextNode(address));
            mapEntryAddress.className = 'modal--entry__address';
        let mapEntryTitle = document.createElement('h2');
            mapEntryTitle.appendChild(document.createTextNode(title));
            mapEntryTitle.className = 'modal--entry__title';
        let mapEntryDate = document.createElement('time');
            mapEntryDate.appendChild(document.createTextNode(date));
            mapEntryDate.className = 'modal--entry__date';
        
        mapEntrySummary.appendChild(mapEntryCategory);
        mapEntrySummary.appendChild(mapEntryAddress);
        mapEntrySummary.appendChild(mapEntryTitle);
        mapEntrySummary.appendChild(mapEntryDate);

        let mapEntryContent = document.createElement('div');
            mapEntryContent.className = 'modal--content';
            mapEntryContent.setAttribute('id', 'mapEntryContent');

        if(description != 'undefined') {
            let mapEntryDescription = document.createElement('p');
                mapEntryDescription.appendChild(document.createTextNode(description));
                mapEntryDescription.className = 'modal--entry__description';
                mapEntryContent.appendChild(mapEntryDescription);
        }

        mapEntryHeader.appendChild(mapEntrySummary);
        mapEntryHeader.appendChild(mapEntryContent);

        mapEntryBox.appendChild(mapEntryHeader);

    let mapEntryContainer = document.createElement('div');
        mapEntryContainer.setAttribute('id', 'mapEntry');
        mapEntryContainer.style.height = '240px';

    mapEntryBox.appendChild(mapEntryContainer);

    let tiles = L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
    });

    let map = L.map(mapEntryContainer, {
        center: L.latLng(lat, lon),
        zoom: 13,
        tileSize: 512,
        zoomOffset: -1,
        attributionControl: true,
        closePopupOnClick: false,
        doubleClickZoom: true,
        dragging: true,
        fadeAnimation: true,
        layerControl: true,
        minZoom: 0,
        scrollWheelZoom: 1,
        touchZoom: true,
        trackResize: true,
        zoomAnimation: true,
        zoomControl: false,
        layers: [tiles]
    });

    const resizeObserver = new ResizeObserver(() => {
        map.invalidateSize();
    });
    resizeObserver.observe(mapEntryContainer);

    let marker = L.marker([lat, lon], {
        icon: L.divIcon({
            className: 'marker--icon',
            html: '<div class="marker map--marker marker--' + state + ' is--active" data-name="' + title + '" data-lat="' + String(lat) + '" data-lon="' + String(lon) + '">' + title + '</div>'
        })
    });

    marker.addTo(map);

    toggleOverlay(true, mapEntryBox, {
        fullwidth: true
    });
}

// Map Entries

function updateMapFooter(record) {
    let mapEntryFooter = document.querySelector('.map--list__footer');
    let mapPostList = document.querySelector('.map--post__list');
    let mapEntryFooterBtn = document.querySelector('.map--show__more');
    let currentActiveValue = Number(mapPostList.getAttribute('data-active'));

    // Footer handler
    if(String(record[0].attributeName) === 'data-active') {
        let noEntries = document.createElement('div');
            noEntries.className = 'error';
            noEntries.appendChild(document.createTextNode('Keine Beiträge gefunden. Bitte wählen Sie eine Kategorie aus.'))

        if(document.querySelectorAll('.error').length > 0) {
            document.querySelectorAll('.error')[0].remove();
        }

        if(currentActiveValue < 10) {
            mapPostList.classList.remove('is--restricted');
            mapEntryFooter.style.display = 'none';

            if(currentActiveValue === 0) {
                document.querySelector('#mapEntries').appendChild(noEntries);
            }
        } else {
            mapPostList.classList.add('is--restricted');
            mapEntryFooter.style.display = 'flex';
        }
    }

    // Footer Button handler
    if(mapPostList.classList.contains('is--restricted')) {
        mapEntryFooterBtn.innerHTML = 'Alle Beiträge anzeigen (' + currentActiveValue + ')';
    }
}

function createMapEntries(container, data) {
    let mapEntries = data[1];

    // Entries
    let mapEntriesContainer = document.createElement('div');
        mapEntriesContainer.setAttribute('id', 'mapEntries');

    let mapEntryList = document.createElement('ul');
        mapEntryList.className = 'map--post__list';
        mapEntryList.setAttribute('data-active', String(mapEntries.length));

    for(let i = 0; i < mapEntries.length; i++) {
        let category = String(mapEntries[i].state),
            title = String(mapEntries[i].title),
            date = String(timeConverter(Date.parse(mapEntries[i].createdDate))),
            description = String(mapEntries[i].description),
            resumee = description.substring(0, 200) + '...',
            lat = convertCoordsStringtoFloat(mapEntries[i].lat),
            lon = convertCoordsStringtoFloat(mapEntries[i].lon),
            state = convertMarkerState(mapEntries[i].state),
            address = String(mapEntries[i].address);

        if((String(mapEntries[i].published) === 'Ja')) {
            let mapEntry = document.createElement('li');
                mapEntry.className = 'map--post__entry entry--' + String(state) + ' is--active';

            let mapEntryMarkerContainer = document.createElement('div');
                mapEntryMarkerContainer.className = 'map--post__marker';
            let mapEntryMarker = document.createElement('div');
                mapEntryMarker.className = 'marker marker--' + String(state);

                mapEntryMarkerContainer.appendChild(mapEntryMarker);

            let mapEntryContent = document.createElement('div');
                mapEntryContent.className = 'map--post__content';

            // Post assets
            let mapEntryCategory = document.createElement('span');
                mapEntryCategory.className = 'map--post__category category--' + String(state);
                mapEntryCategory.appendChild(document.createTextNode(category));
            let mapEntryTitle = document.createElement('h3');
                mapEntryTitle.className = 'map--post__title';
                mapEntryTitle.appendChild(document.createTextNode(title));
            let mapEntryDate = document.createElement('time');
                mapEntryDate.className = 'map--post__date';
                mapEntryDate.appendChild(document.createTextNode(date));

                // Append
                mapEntryContent.appendChild(mapEntryCategory);
                mapEntryContent.appendChild(mapEntryTitle);
                mapEntryContent.appendChild(mapEntryDate);

            // Check if description is available
            if(String(mapEntries[i].description) !== 'undefined') {
                let mapEntrySummary = document.createElement('p');
                    mapEntrySummary.className = 'map--post__summary';
                    mapEntrySummary.appendChild(document.createTextNode(resumee));

                    mapEntryContent.appendChild(mapEntrySummary);
            }

            mapEntry.addEventListener('click', function(e) {
                e.preventDefault();
                openMapEntryModal(data, category, title, date, description, lat, lon, state, address);
            })

            mapEntry.appendChild(mapEntryMarkerContainer);
            mapEntry.appendChild(mapEntryContent);
            mapEntryList.appendChild(mapEntry);
        }
    }

    let mapEntryFooter = document.createElement('footer');
        mapEntryFooter.className = 'map--list__footer';
    let mapEntryMoreBtn = document.createElement('button');
        mapEntryMoreBtn.innerText = 'Alle Beiträge anzeigen (' + String(mapEntries.length) + ')';
        mapEntryMoreBtn.className = 'btn bigbtn map--show__more';
        mapEntryList.classList.add('is--restricted');

    mapEntryFooter.appendChild(mapEntryMoreBtn);

    mapEntryMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();

        if(mapEntryList.classList.contains('is--restricted')) {
            mapEntryList.classList.remove('is--restricted');
            mapEntryFooter.classList.add('is--moving');
            mapEntryMoreBtn.innerText = 'Beiträge ausblenden';

            if(document.body.clientWidth >= 1024) {
                mapEntryFooter.style.maxWidth = String(document.querySelector('.content').offsetWidth) + 'px';
            } else {
                mapEntryFooter.style.maxWidth = 'calc(100% - 62px)';
            }

        } else {
            mapEntryFooter.style.bottom = '0px';
            mapEntryList.classList.add('is--restricted');
            mapEntryFooter.classList.remove('is--moving');
            mapEntryMoreBtn.innerText = 'Alle Beiträge anzeigen';
            mapEntryFooter.style.maxWidth = '';
        }
    })

    mapEntriesContainer.appendChild(mapEntryList);
    mapEntriesContainer.appendChild(mapEntryFooter);

    const mapEntryObserver = new MutationObserver(record => {
        updateMapFooter(record);
    });
    
    mapEntryObserver.observe(mapEntryList, {
        attributes: true
    });

    window.addEventListener('resize', function() {
        // Resize
        let isSidebarThere = document.querySelectorAll('.sidebar');

        // Going to Desktop from Mobile
        if(document.body.clientWidth >= 1024) {
            //Desktop
            if(mapEntryFooter.classList.contains('is--moving')) {
                // when moving
                mapEntryFooter.style.maxWidth = String(document.querySelector('.content').offsetWidth) + 'px'; // footer width to content width

                // if is bottom
                //// adjust bottom value
                if (window.innerHeight + window.pageYOffset >= (document.body.scrollHeight - Number(document.querySelector('.page--footer').offsetHeight) - 75)) {
                    mapEntryFooter.classList.remove('is--moving');
                    mapEntryFooter.style.bottom = '0px'; // Desktop bottom reached
                } else {
                    mapEntryFooter.classList.add('is--moving');
                    mapEntryFooter.style.bottom = '0px';  // Mobile bottom not reached
                }
            } else {
                mapEntryFooter.style.bottom = '';
                mapEntryFooter.style.maxWidth = '';
            }
        } else {
            // Going to Mobile
            if(mapEntryFooter.classList.contains('is--moving')) {
                // when moving
                mapEntryFooter.style.bottom = '0px';
                mapEntryFooter.style.maxWidth = 'calc(100% - 62px)';

                // if is bottom
                //// adjust bottom value
                if (window.innerHeight + window.pageYOffset >= (document.body.scrollHeight - (Number(isSidebarThere.length) > 0 ? Number(document.querySelector('.sidebar').scrollHeight) : 0) - Number(document.querySelector('.page--footer').scrollHeight) - 75)) {
                    mapEntryFooter.classList.remove('is--moving'); // while moving
                    mapEntryFooter.style.bottom = '0px';  // Mobile bottom not reached
                } else {
                    mapEntryFooter.classList.add('is--moving'); // at the bottom
                    mapEntryFooter.style.bottom = '0px';  // Mobile bottom not reached
                }
            } else {
                mapEntryFooter.style.bottom = '0px';
                mapEntryFooter.style.maxWidth = 'calc(100% - 62px)';
            }
        }
    });

    window.addEventListener('scroll', function() {
        // Scroll
        // Desktop is-moving - what happens when bottom is reached
        // Mobile is-moving - what happens when bottom is reached
        let isSidebarThere = document.querySelectorAll('.sidebar');

        if(document.body.clientWidth >= 1024) {
            if(mapEntryFooter.classList.contains('is--moving')) {
                if (window.innerHeight + window.pageYOffset >= (document.body.scrollHeight - Number(document.querySelector('.page--footer').offsetHeight) - 50)) {
                    mapEntryFooter.style.bottom = '235px'; // Desktop bottom reached
                } else {
                    mapEntryFooter.style.bottom = '0px'; // Desktop bottom not reached
                }
            }
        } else {
            if(mapEntryFooter.classList.contains('is--moving')) {
                if (window.innerHeight + window.pageYOffset < (document.body.scrollHeight - (Number(isSidebarThere.length) > 0 ? Number(document.querySelector('.sidebar').scrollHeight) : 0) - Number(document.querySelector('.page--footer').scrollHeight) - 75)) {
                    mapEntryFooter.style.bottom = '0px';  // Mobile bottom not reached
                } else {
                    mapEntryFooter.style.bottom = '375px'; // Mobile bottom reached
                }
            }
        }
    });

    container.appendChild(mapEntriesContainer);
}

async function fetchObLebenMapData(container) {
	container.innerHTML = '';

    const response = await fetch('/dgdata/ostbelgienleben2040/data_map_comments.json', {
		method: 'GET',
		mode: 'cors'
	})
	.then(response => response.json())
	.then(data => {
        createLeafletMap(container, Object.entries(data)[0])
        createMapEntries(container, Object.entries(data)[0])
	})
	.catch(function(error) {
		console.error(error);
	});
}

function fetchObLebenContainer() {
	let container = document.querySelector('#ObLebenExport');
	return container;
}

function executeFunctionByName(functionName, context /*, args */) {
    var args = Array.prototype.slice.call(arguments, 2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for (var i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
}

let OBLebenContainer = document.querySelector('#ObLebenExport');

if(OBLebenContainer != null) {
	// createBreadcrumbEntry('Ostbelgien leben 2040');

	switch(OBLebenContainer.getAttribute('data-origin')) {
		case 'obleben2040-poll':
			fetchObLebenPollData(OBLebenContainer);
			break;
		case 'obleben2040-map':
			fetchObLebenMapData(OBLebenContainer);
			break;
		default:
			isExportPage.appendChild(document.createElement('div').className('error').appendChild(document.createTextNode('Error: Unknown export origin')));
	}
}